function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#6A2375",
  cx: 64,
  cy: 64,
  r: 64
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.752 61.938v-8.723H79.745c-2.948 0-4.422 1.513-4.422 4.52v4.203h14.43m4.41 20.65c-2.948 0-4.41-1.488-4.41-4.466v-7.31l-14.406-.028-.024 7.338c0 2.978-1.45 4.466-4.34 4.466-2.912 0-4.35-1.462-4.35-4.403V57.914c0-9.01 4.35-13.508 13.027-13.508l14.43.026c2.888 0 4.326 1.451 4.326 4.345v29.345c0 2.978-1.414 4.466-4.253 4.466m-34.31-37.996c-2.829 0-4.24 1.457-4.24 4.37V68.92c0 2.948-1.451 4.427-4.34 4.427h-8.407c-2.901 0-4.34-1.479-4.34-4.427V48.963c0-2.914-1.425-4.37-4.253-4.37-2.84 0-4.255 1.436-4.255 4.307v19.85c0 8.814 4.255 13.223 12.762 13.223h.035v10.793c0 2.872 1.416 4.304 4.242 4.304 2.84 0 4.253-1.45 4.253-4.36V81.972h.05c8.493 0 12.747-4.409 12.747-13.224V48.9c0-2.871-1.416-4.308-4.254-4.308",
  fill: "#FC0"
}));

function SvgYa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYa);
export default __webpack_public_path__ + "static/media/ya.9bc3eaea.svg";
export { ForwardRef as ReactComponent };